<template>
  <v-app>
    <Toolbar v-if="isUserAuthenticated"></Toolbar>
    <main>
      <v-main>
        <router-view></router-view>
      </v-main>
    </main>
    <div @mouseover="hideFooterFct">
      <v-footer v-if="isUserAuthenticated && showTimeout"
                app
                dark
                color="#01579B"
                style="z-index:200"
      >
        <v-spacer></v-spacer>
        <div v-if="isMobile ===false" style="font-weight: 300;color: #f5f5f5">
          Powered with
          <v-icon class="blink" style="color: red;">mdi-cards-heart</v-icon>
          by CartaLink V{{ appVersion }} -
        </div>
        <div v-else style="width: 100%;font-weight: 300;color: #f5f5f5;text-align:center">Powered by CartaLink
          V{{ appVersion }}
        </div>
        <div v-if="isMobile===false" style="font-weight: 300;color: #f5f5f5">- &copy;{{ new Date().getFullYear() }}
          TSA
        </div>
      </v-footer>
    </div>

    <!-- Notification de mise à jour centrée avec nouvelle couleur -->
    <!-- Snackbar modifié pour éviter la "lentille" -->
    <v-snackbar
        v-model="showUpdateNotification"
        :timeout="-1"
        color="#FF5722"
        centered
        class="update-notification"
        width="400"
        elevation="8"
        multi-line
    >
      <div>
        <span class="white--text font-weight-medium">Nouvelle version disponible (V{{ versionFrontOnServer }})</span>
        <p class="white--text mt-2 mb-3">
          Mise à jour automatique dans {{ updateCountdown }} secondes...
        </p>
      </div>
      <template v-slot:action>
        <v-btn
            text
            color="white"
            class="mr-3"
            @click="laterUpdate"
        >
          Plus tard
        </v-btn>
        <v-btn
            text
            color="white"
            @click="refreshApp"
        >
          Maintenant
        </v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>

<script>
import Toolbar from "./components/Toolbar";
import packageInfo from '../package.json'
import { compare } from "compare-versions";
import apiClient from "./config/api.js";

function isMobileDevice() {
  return /Mobi|Android/i.test(navigator.userAgent);
}

export default {
  name: "App",
  components: {
    Toolbar
  },
  data() {
    return {
      isMobile: isMobileDevice(),
      appVersion: packageInfo.version,
      sideNav: false,
      showTimeout: true,

      // Propriétés pour la gestion de mise à jour
      showUpdateNotification: false,
      registration: null,
      refreshing: false,
      versionFrontOnServer: '',
      intervalFrontTimer: 300000, // 5 minutes en production
      timerRefreshFront: null,
      lastCheckTime: 0,
      isChecking: false,
      updateCountdown: 30,
      countdownTimer: null
    };
  },
  computed: {
    isUserAuthenticated() {
      return (
          this.$store.getters.user !== null &&
          this.$store.getters.user !== undefined
      );
    },
  },
  methods: {
    hideFooterFct() {
      var v = this;
      v.showTimeout = false;
      setTimeout(function () {
        v.showTimeout = true;
      }, 10000);
    },

    refreshApp() {
      // Nettoyer tous les timers
      clearInterval(this.timerRefreshFront);
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer);
        this.countdownTimer = null;
      }

      // Supprimer le flag de mise à jour en attente
      sessionStorage.removeItem('pendingUpdate');

      // Forcer un rechargement avec paramètre anti-cache
      window.location.href = window.location.href.split('?')[0] + '?forceUpdate=' + Date.now();

      this.showUpdateNotification = false;
    },

    laterUpdate() {
      // Cacher la notification
      this.showUpdateNotification = false;

      // Arrêter le compte à rebours
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer);
        this.countdownTimer = null;
      }

      // Stocker le moment du report
      sessionStorage.setItem('updateLater', Date.now().toString());

      // Réactiver le timer pour vérifier plus tard (15 minutes)
      if (!this.timerRefreshFront) {
        this.timerRefreshFront = setInterval(() => {
          this.checkFrontVersion(false);
        }, 15 * 60 * 1000);
      }
    },

    checkFrontVersion(isManualCheck = false) {
      // Éviter les vérifications simultanées
      if (this.isChecking) return;

      // Éviter les vérifications trop fréquentes
      const now = Date.now();
      if (!isManualCheck && (now - this.lastCheckTime < 30000)) return;

      this.lastCheckTime = now;
      this.isChecking = true;

      if (!this.$store.getters.user || !this.$store.getters.user.baseUrl) {
        this.isChecking = false;
        return;
      }

      // Ajouter un timestamp anti-cache
      const url = `${this.$store.getters.user.baseUrl}/account/versionfront?nocache=${Date.now()}`;

      apiClient
          .get(url)
          .then(response => {
            if (response && response.data && response.data.datas) {
              this.versionFrontOnServer = response.data.datas;

              // Normaliser les versions
              const normalizedServerVersion = this.versionFrontOnServer.replace(/\.0+(\d)/g, ".$1");
              const normalizedLocalVersion = this.appVersion.replace(/\.0+(\d)/g, ".$1");

              // Comparer les versions
              const isNewer = compare(normalizedServerVersion, normalizedLocalVersion, '>');

              if (isNewer) {
                // Arrêter les vérifications automatiques
                clearInterval(this.timerRefreshFront);
                this.timerRefreshFront = null;

                // Stocker la mise à jour en attente
                sessionStorage.setItem('pendingUpdate', JSON.stringify({
                  version: this.versionFrontOnServer,
                  checkDate: new Date().toISOString()
                }));

                // Afficher la notification
                this.showUpdateNotification = true;

                // Initialiser et démarrer le compte à rebours
                this.updateCountdown = 30;
                if (this.countdownTimer) {
                  clearInterval(this.countdownTimer);
                }
                this.countdownTimer = setInterval(() => {
                  this.updateCountdown--;
                  if (this.updateCountdown <= 0) {
                    clearInterval(this.countdownTimer);
                    this.countdownTimer = null;
                    this.refreshApp();
                  }
                }, 1000);
              }
            }
          })
          .catch(() => {})
          .finally(() => {
            this.isChecking = false;
          });
    },

    checkPendingUpdate() {
      try {
        const pendingUpdateStr = sessionStorage.getItem('pendingUpdate');
        if (!pendingUpdateStr) return;

        const pendingUpdate = JSON.parse(pendingUpdateStr);
        if (pendingUpdate && pendingUpdate.version) {
          this.versionFrontOnServer = pendingUpdate.version;

          // Normaliser les versions
          const normalizedServerVersion = this.versionFrontOnServer.replace(/\.0+(\d)/g, ".$1");
          const normalizedLocalVersion = this.appVersion.replace(/\.0+(\d)/g, ".$1");

          if (compare(normalizedServerVersion, normalizedLocalVersion, '>')) {
            // Vérifier si l'utilisateur a reporté récemment
            const laterTime = sessionStorage.getItem('updateLater');
            if (laterTime) {
              const elapsed = Date.now() - parseInt(laterTime);
              if (elapsed < 15 * 60 * 1000) return; // Moins de 15 minutes
            }

            this.showUpdateNotification = true;

            // Arrêter les vérifications automatiques
            clearInterval(this.timerRefreshFront);
            this.timerRefreshFront = null;

            // Initialiser et démarrer le compte à rebours
            this.updateCountdown = 30;
            if (this.countdownTimer) {
              clearInterval(this.countdownTimer);
            }
            this.countdownTimer = setInterval(() => {
              this.updateCountdown--;
              if (this.updateCountdown <= 0) {
                clearInterval(this.countdownTimer);
                this.countdownTimer = null;
                this.refreshApp();
              }
            }, 1000);
          } else {
            sessionStorage.removeItem('pendingUpdate');
          }
        }
      } catch (error) {
        sessionStorage.removeItem('pendingUpdate');
      }
    },

    // Méthode que les composants enfants peuvent appeler
    triggerUpdateCheck() {
      this.checkPendingUpdate();
    }
  },
  mounted() {
    // Ne vérifier les mises à jour que si l'utilisateur est authentifié
    if (this.isUserAuthenticated) {
      this.checkPendingUpdate();
      this.checkFrontVersion(true);
      this.timerRefreshFront = setInterval(() => {
        this.checkFrontVersion(false);
      }, this.intervalFrontTimer);
    } else {
      // Surveiller les changements d'authentification
      this.$watch('isUserAuthenticated', (newValue) => {
        if (newValue === true) {
          this.checkPendingUpdate();
          this.checkFrontVersion(true);
          this.timerRefreshFront = setInterval(() => {
            this.checkFrontVersion(false);
          }, this.intervalFrontTimer);
        }
      });
    }

    // Écouter l'événement de mise à jour du service worker
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker && navigator.serviceWorker.addEventListener('controllerchange', () => {
        if (!this.refreshing) {
          this.refreshing = true;
          window.location.reload();
        }
      });
    }
  },
  beforeDestroy() {
    // Nettoyer les intervalles
    if (this.timerRefreshFront) {
      clearInterval(this.timerRefreshFront);
    }
    if (this.countdownTimer) {
      clearInterval(this.countdownTimer);
    }
  }
}
</script>

<style>
@import '~handsontable/dist/handsontable.full.css';

/* Style pour le snackbar de notification */
.update-notification {
  border-radius: 8px;
}

.update-notification .v-btn {
  font-weight: 500;
  border-radius: 4px;
  padding: 0 16px;
}

.handsontable table thead th {
  color: #607D8B !important;
  background: #F5F5F5 !important;
  font-size: 15px;
  font-weight: bold;
}

.htCore > tbody > tr:nth-child(even) > td {
  background-color: #f5f5f5;
}

.htCore > tbody > tr:nth-child(odd) > td {
  background-color: #ffffff;
}

.wtBorder {
  background-color: #01579B !important;
}

/* Selected row  */
.ht_master tr.foo > td {
  background-color: #f00;
}

.vdatetime-calendar__month__day--selected > span > span, .vdatetime-calendar__month__day--selected:hover > span > span {
  background: #01579B !important;
}

.vdatetime-popup__header {
  background: #01579B !important;
}

.vdatetime-popup__actions__button {
  color: #01579B !important;
}

.blink {
  animation: blink-animation 5s steps(5, start) infinite;
  -webkit-animation: blink-animation 5s steps(5, start) infinite;
}

@keyframes blink-animation {
  to {
    visibility: hidden;
  }
}

@-webkit-keyframes blink-animation {
  to {
    visibility: hidden;
  }
}

.centered-input input {
  text-align: center !important;
}

.centered-input.v-text-field .v-label {
  left: 50% !important;
  transform: translateX(-50%);
  transform-origin: 50% 0%;
}

.centered-input.v-text-field .v-label.v-label--active {
  transform: translateY(-23px) scale(1) translateX(-50%);
  color: #01579B;
}

.v-select__selection {
  width: 100% !important;
  transform: translateX(10%);
}

.downbox:hover,
.downbox.over {
  background-color: lightgoldenrodyellow !important;
  cursor: pointer !important;
}

.v-select__selections {
  height: 45px !important;
}

.v-list .v-list-item--active {
  background-color: #B0BEC5 !important;
}

.v-list .v-list-item--active .v-list-item__title {
  color: white !important;
}

.v-select__selections input {
  display: none;
  color: #f0f0f0;
}

.multi-line {
  white-space: pre-line !important;
}

.rowHighlight {
  background-color: #d0e1ef !important;
}

/* Footer centering styles */
.footer-centered {
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  text-align: center !important;
}

.footer-content-desktop {
  font-weight: 300;
  color: #f5f5f5;
  text-align: center;
  white-space: nowrap;
}

.footer-content-mobile {
  width: 100%;
  font-weight: 300;
  color: #f5f5f5;
  text-align: center;
}

.footer-text {
  font-weight: 300;
  color: #f5f5f5;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.footer-text-mobile {
  font-weight: 300;
  color: #f5f5f5;
  text-align: center;
}

.footer-heart {
  color: red !important;
  margin: 0 2px;
}

/* Ensure footer content doesn't overflow */
.footer-centered .v-footer__wrapper {
  justify-content: center;
  width: 100%;
}

/* Alternative approach using CSS Grid */
.footer-grid {
  display: grid !important;
  place-items: center !important;
  width: 100% !important;
}

/* Responsive adjustments */
@media (max-width: 600px) {
  .footer-text {
    font-size: 12px;
  }

  .footer-text-mobile {
    font-size: 12px;
  }

  .footer-heart {
    font-size: 16px !important;
  }
}

/* Remove default spacers when centering */
.footer-centered .v-spacer {
  display: none !important;
}
</style>